module.exports = (state, action) => {
  const activity = action.payload
  const activityId = activity.id
  if (activityId !== undefined && state.activities[activityId] !== undefined) {
    // Instead of an object, we could use a Map, so we make sure we only remove each box once.
    state.activities[activityId] = undefined
    state.activitiesCounter = state.activitiesCounter - 1
  } else {
    throw new Error(`Cannot delete activity with id:${activityId}`)
  }
}
